'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var SIZE_CLASSES = exports.SIZE_CLASSES = {
  default: 'private-button--default',
  small: 'private-button--sm',
  'extra-small': 'private-button--xs',
  medium: 'private-button--default'
};

var USE_CLASSES = exports.USE_CLASSES = {
  danger: 'private-button--destructive',
  link: 'private-button__link',
  'link-danger': 'private-button__link private-button__link--danger',
  'link-on-dark': 'private-button__link private-button__link--on-dark',
  'link-on-bright': 'private-button__link private-button__link--on-bright',
  primary: 'private-button--primary',
  'primary-white': 'private-button--primary--white',
  secondary: 'private-button--secondary',
  'secondary-ghost': 'private-button--secondary--ghost',
  tertiary: 'private-button--tertiary',
  'tertiary-light': 'private-button--tertiary-light',
  'tertiary-extra-light': 'private-button--tertiary-extra-light',
  transparent: 'private-button--transparent',
  unstyled: 'private-button--unstyled',
  form: 'private-button--form private-form__control',
  'form-on-dark': 'private-button--form private-form__control private-button--form--on-dark'
};

var LINK_USES = exports.LINK_USES = ['link', 'link-danger', 'link-on-dark'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.2750/js/button/ButtonConstants.js
// module id = 182
// module chunks = 171